import React, { useState } from 'react';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import OnboardingAddItemButton
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ExpensesDetail/OnboardingAddItemButton';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

export const SelectOutcomesStepTemplate = () => {
  const [submitting, setSubmitting] = useState(false);
  const {
    resource,
    onSubmit,
  } = useMetaLayoutContext();
  const { loadModalCollectionByLink, setModalCollection } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      const nextModelCollection = await onSubmit();
      setModalCollection(nextModelCollection);
    } catch (e) {
      displayErrorMessage(e, e.errors || 'failed to add new goals. If this issue persists please contact support.');
    } finally {
      setSubmitting(false);
    }
  };


  const AddCustomGoalButton = resource.withRelationship(fr.relationships.addCustomGoal.name,
    (rel) => <OnboardingAddItemButton relationship={rel} onAdd={() => loadModalCollectionByLink(rel.link('related').url())} />,
    () => null);

  return (
    <FDStack direction={'column'} paddingX={4} paddingY={5} spacing={3} alignItems={'center'} width={'100%'}>
      <MetaControlField attr={'goal'} />
      {AddCustomGoalButton}
      <FDPrimaryActionButton
        onClick={handleSubmit}
        loading={submitting}
        disabled={submitting || resource.attr('goal') === ''}
        label={'Continue'}
      />
    </FDStack>
  );
};
